module.exports = __webpack_public_path__ + "img/d37a826.svg";